import React, { useContext, useEffect, useState } from 'react';
import './App.css';
import "./styles/global.css";
import "./styles/themes/software.css";

import { ThemeProvider, ThemeContext } from './context/ThemeContext';

import { Divider, Box } from "@mui/material";
import { Routes, Route, BrowserRouter, Navigate, useLocation } from "react-router-dom";
import Header from './components/Header';
import SidebarMenu from './components/SidebarMenu';

import FlowHome from './components/workflow/FlowHome';
import FlowServices from './components/workflow/FlowServices';
import FlowAbout from './components/workflow/FlowAbout';
import FlowContact from './components/workflow/FlowContact';

import GuideHome from './components/guidance/GuideHome';
import GuideRequire from './components/guidance/GuideRequire';
import GuideFacilities from './components/guidance/GuideFacilities';
import GuideAbout from './components/guidance/GuideAbout';
import GuideContact from './components/guidance/GuideContact';

import Home from './components/itsupport/Home';
import About from './components/itsupport/About';
import ItSupport from './components/itsupport/ItSupport';
import WebDevelop from './components/softwaresolution/WebDevelop';
import Contact from './components/itsupport/Contact';
import Career from './components/itsupport/Career';

import SwHome from './components/softwaresolution/SwHome';
import SwAbout from './components/softwaresolution/SwAbout';
import SwServices from './components/itsupport/SwServices';
import SwContact from './components/softwaresolution/SwContact';
import Footer from './components/Footer';
import Dataengineering from './components/itsupport/Dataengineering';
import Chat from './components/itsupport/chat';
import muiTheme from './context/theme'; // Your Material-UI theme file
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Booking from './components/workflow/Booking';
import VatCalculator from './components/VatCalculator/VatCalculator';




function AppRoutes() {
  const { setSite } = useContext(ThemeContext);
  const location = useLocation();

  // Update site based on path
  useEffect(() => {
    const path = location.pathname.split('/')[1];

    if (path === "guidance" || path === "itsupport" || path === "workflow") {
      setSite(path);
    }
  }, [location.pathname, setSite]);

  return (
    <Routes>
      {/* Root redirect */}
      <Route path="/" element={<Navigate to="home" replace />} />

      {/* Guidance */}
      <Route path="/guidance/home" element={<GuideHome />} />
      <Route path="/guidance/require" element={<GuideRequire />} />
      <Route path="/guidance/facilities" element={<GuideFacilities />} />
      <Route path="/guidance/about" element={<GuideAbout />} />
      <Route path="/guidance/contact" element={<GuideContact />} />

      {/* IT Support */}
      <Route path="/home" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/itservices" element={<ItSupport />} />
      <Route path="/swservices" element={<SwServices />} />
      <Route path="/dataservices" element={<Dataengineering />} />
      <Route path="/careers" element={<Career />} />
      <Route path="/contact" element={<Contact />} />

      {/* Flow Support */}
      <Route path="/workflow/home" element={<FlowHome />} />
      <Route path="/workflow/services" element={<FlowServices />} />
      <Route path="/workflow/booking" element={<Booking />} />
      <Route path="/workflow/about" element={<FlowAbout />} />
      <Route path="/workflow/contact" element={<FlowContact />} />

      <Route path="/workflow" element={<FlowHome />} />
      <Route path="/guidance" element={< GuideHome />} />
      <Route path="/" element={<Home />} />


    </Routes>
  );
}

function App() {
  const location = useLocation();
  const sitePath = location.pathname.split('/')[1];
  const isWorkflowSite = sitePath === 'workflow';
  const isCalculator = sitePath === 'vatcalculator';

  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  const handleSidebarToggle = () => setIsSidebarOpen(!isSidebarOpen);

  const sidebarOpenWidth = 250;
  const sidebarClosedWidth = 56;

  return (
    <MuiThemeProvider theme={muiTheme}>
      <CssBaseline />
      <ThemeProvider>

        <Header />
        <SidebarMenu open={isSidebarOpen} onClose={handleSidebarToggle} />
        <Divider />


        {/* Main content dynamically shifted by sidebar width */}
        <Box
          component="main"
          sx={{
            transition: 'margin-left 0.3s ease-in-out',
            ml: isSidebarOpen ? `${sidebarOpenWidth}px` : `${sidebarClosedWidth}px`, // sidebar widths
            //paddingTop: 'var(--header-height, 64px)',
            px: 2,
            pr: 0,
            pl: 0,
            backgroundColor: 'var(--body-bg, #f7f7f7)',
            minHeight: '100vh',
          }}
        >


          <AppRoutes />
          {isCalculator && <VatCalculator />}
        </Box>
        {/* Conditionally render footer */}
        {!isWorkflowSite && <Footer />}

      </ThemeProvider>
    </MuiThemeProvider>
  );
}

export default App;
